import { useMediaQuery } from '@uhg-abyss/web/hooks/useMediaQuery';

import {
  carouselScreen,
  fourCardscarouselScreen,
  sixCardscarouselScreen,
  threeCardscarouselScreen,
  twoCardscarouselScreen,
} from '../common/ConstantsStyles';
import { isPremiumCareDisplayEligible } from '../common/DataCard/DataCardUtils';
import { checkTerminationDate } from '../common/Utils/terminateDateIndicatorUtils';
import { isProviderStartDateInFuture } from './date.utils';
import { getPremiumCarePhysician } from './providerDetails.utils';

export const getSnackCardDisplayValByLength = (reviewCardsCount): boolean => {
  const bSixCardDisplayCarousel = useMediaQuery(sixCardscarouselScreen);
  const bFiveCardsDisplayCarousel = useMediaQuery(carouselScreen);
  const bFourCardDisplayCarousel = useMediaQuery(fourCardscarouselScreen);
  const bThreeCardDisplayCarousel = useMediaQuery(threeCardscarouselScreen);
  const bTwoCardDisplayCarousel = useMediaQuery(twoCardscarouselScreen);
  const b = false;
  if (reviewCardsCount === 2) {
    return bTwoCardDisplayCarousel;
  }
  if (reviewCardsCount === 3) {
    return bThreeCardDisplayCarousel;
  }
  if (reviewCardsCount === 4) {
    return bFourCardDisplayCarousel;
  }
  if (reviewCardsCount === 5) {
    return bFiveCardsDisplayCarousel;
  }
  if (reviewCardsCount > 5) {
    return bSixCardDisplayCarousel;
  }
  return b;
};

export const getMaxBadgeCount = (
  snackCardProviders,
  isPlatinumProviderIdentifierEnabled: boolean,
  suppressPremiumCare: boolean = false,
  isMultipleBadgeCardViewEnabled: boolean,
  displayTerminationDateEnabled: boolean
): number => {
  if (!snackCardProviders || snackCardProviders.length === 0) {
    return 0;
  }
  return snackCardProviders.reduce((maxCount, snackCardProvider) => {
    const badgeConditions = [
      isPlatinumProviderIdentifierEnabled &&
        snackCardProvider?.isPlatinumProvider,
      isProviderStartDateInFuture(snackCardProvider?.networkStartDate),
      checkTerminationDate(
        displayTerminationDateEnabled,
        snackCardProvider?.networkEndDate
      ),
      isMultipleBadgeCardViewEnabled &&
        isPremiumCareDisplayEligible(
          !suppressPremiumCare,
          getPremiumCarePhysician(snackCardProvider?.isPremiumCarePhysician)
        ),
    ];

    const validBadgeCount = badgeConditions.filter(Boolean).length;
    return Math.max(maxCount, validBadgeCount);
  }, 0);
};

export const capitalizeFirstLetterOfEachWord = (
  textString?: string | null
): string => {
  if (textString !== undefined && textString != null && textString.length > 0) {
    return textString
      .split(' ')
      .map(
        (word) => word?.charAt(0)?.toUpperCase() + word.slice(1).toLowerCase()
      )
      .join(' ');
  }
  return '';
};
